module.exports = __webpack_public_path__ + "static_pc/img/2.e2593991.jpg";